import { render, staticRenderFns } from "./l-menu.vue?vue&type=template&id=c126550c&scoped=true"
import script from "./l-menu.vue?vue&type=script&lang=js"
export * from "./l-menu.vue?vue&type=script&lang=js"
import style0 from "./l-menu.vue?vue&type=style&index=0&id=c126550c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126550c",
  null
  
)

export default component.exports